import mall from './mall'
const routes = [
  ...mall,
]

export default routes



// WEBPACK FOOTER //
// ./src/router/routes.js